import React, { useState } from "react";
import { ExpandLess, ExpandMore, GitHub, OpenInNew } from "@mui/icons-material";
import { projects } from "../data/portfolioData";
import ourTasksImage from "../static/project-ourtasks.webp";
import portfolioImage from "../static/project-portfolio.webp";
import snapCookImage from "../static/project-snap-cook.webp";
import quickQueryImage from "../static/project-quickquery.webp";
import smartHomeImage from "../static/project-smart-home.webp";
import enigmaImage from "../static/project-enigma.webp";
import "./Projects.css";

const projectImages = {
  OurTasks: ourTasksImage,
  "Personal Portfolio": portfolioImage,
  "Snap & Cook": snapCookImage,
  QuickQuery: quickQueryImage,
  "Smart Home Automation": smartHomeImage,
  Enigma: enigmaImage,
};

const Projects = () => {
  const [showAll, setShowAll] = useState(false);
  const visibleProjects = showAll ? projects : projects.filter((project) => project.featured);

  return (
    <section id="projects" className="portfolio-section projects-section" data-scene-section="projects">
      <div className="section-wrap" data-animate="true">
        <header className="destination-heading destination-heading--split">
          <div>
            <div className="destination-label"><span>04</span><span>Construction gateways</span></div>
            <h2 className="section-title">Products built through constraints.</h2>
          </div>
          <p className="section-lede">Selected systems presented as engineering decisions: the problem, the approach, the build, and what changed.</p>
        </header>
        <div className="projects-gallery">
          {visibleProjects.map((project, index) => (
            <article
              key={project.title}
              className={`project-item ${index % 2 ? "project-item--reverse" : ""}`}
              style={{ "--project-accent": project.accent }}
            >
              {projectImages[project.title] ? (
                <div className="project-screenshot">
                  <img
                    src={projectImages[project.title]}
                    alt={`${project.title} project preview`}
                    loading={index === 0 ? "eager" : "lazy"}
                    fetchpriority={index === 0 ? "high" : "auto"}
                  />
                </div>
              ) : (
                <div className={`project-visual project-visual--${project.visual}`} aria-hidden="true">
                  <span className="project-visual-plane" />
                  <span className="project-visual-orbit" />
                  <span className="project-visual-signal" />
                </div>
              )}
              <div className="project-copy">
                <div className="project-meta">
                  <span>Case {String(projects.indexOf(project) + 1).padStart(2, "0")}</span>
                  <span>{project.category} · {project.year}</span>
                </div>
                <h3>{project.title}</h3>
                <p className="project-subtitle">{project.subtitle}</p>
                <p className="project-summary">{project.summary}</p>
                <dl className="project-decisions">
                  <div><dt>Problem</dt><dd>{project.problem}</dd></div>
                  <div><dt>Decision</dt><dd>{project.decision}</dd></div>
                  <div><dt>Build</dt><dd>{project.implementation}</dd></div>
                  <div><dt>Outcome</dt><dd>{project.outcome}</dd></div>
                </dl>
                <div className="project-footnote">
                  <p className="project-technologies">{project.technologies}</p>
                  <p className="project-metric">{project.metric}</p>
                </div>
                <div className="project-actions">
                  {project.liveLink && (
                    <a className="project-primary-link" href={project.liveLink} target="_blank" rel="noopener noreferrer">
                      View live <OpenInNew fontSize="inherit" aria-hidden="true" />
                    </a>
                  )}
                  {project.articleLink && (
                    <a href={project.articleLink} target="_blank" rel="noopener noreferrer">
                      Read article <OpenInNew fontSize="inherit" aria-hidden="true" />
                    </a>
                  )}
                  {project.github && (
                    <a href={project.github} target="_blank" rel="noopener noreferrer">
                      Source <GitHub fontSize="inherit" aria-hidden="true" />
                    </a>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
        <button className="section-toggle" type="button" onClick={() => setShowAll((current) => !current)} aria-expanded={showAll}>
          {showAll ? "Show featured projects" : `View all ${projects.length} projects`}
          {showAll ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
        </button>
      </div>
    </section>
  );
};

export default Projects;
